module.exports = __webpack_public_path__ + "media/img/frontend_application/noinquiries-f6dea06f06036631b54143d47533de52.png";